"use strict";
// NOTE: If an item in this theme is changed please make the corresponding change in the Sass theme in src/theme/utils.scss
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacingUnits = exports.deprecatedSpacingUnits = exports.spacingBaseUnit = void 0;
exports.spacingBaseUnit = 0.5; // 8px
exports.deprecatedSpacingUnits = [0.25, 0.5, 1, 1.5, 2, 3, 4, 5];
exports.spacingUnits = [
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
];
var SPACING_UNIT_VALUE_MAP = {
    small: 1,
    medium: 2,
    large: 3,
    xlarge: 4,
    xxlarge: 5
};
var colors = {
    blue100: '#E5EEF1',
    blue200: '#A8C4D0',
    blue300: '#0083B2',
    blue400: '#005473',
    blue500: '#003245',
    gray100: '#F1F1F1',
    gray200: '#D9D9D9',
    gray300: '#C0C0C0',
    gray400: '#707070',
    gray500: '#383838',
    green100: '#E5F1EF',
    green200: '#80BAB0',
    green300: '#019C77',
    green400: '#007562',
    green500: '#013F3A',
    maroon100: '#E6D7DC',
    maroon200: '#C09BA7',
    maroon300: '#B2005F',
    maroon400: '#730024',
    maroon500: '#470304',
    orange100: '#FBEDE7',
    orange200: '#ECA389',
    orange300: '#FF6E00',
    orange400: '#D44513',
    orange500: '#A4350F',
    white: '#FFFFFF',
    black: '#000000',
    successBackground: '#F1F8E9',
    warningBackground: '#FFF8E1',
    warningAccessible: '#FF8F00',
    dangerActive: '#B11313'
};
var colorFamily = {
    forms: 'orange'
};
var typography = {
    fontColor: {
        primary: colors.gray500,
        secondary: colors.gray400,
        disabled: colors.gray300,
        green: colors.green400,
        blue: colors.blue400,
        maroon: colors.maroon400,
        orange: colors.orange400,
        white: colors.white,
        black: colors.black,
        inherit: 'inherit'
    },
    fontFamily: {
        serif: 'Lora, Georgia, serif',
        sansSerif: 'Urbanist, Arial, sans-serif'
    },
    fontWeight: {
        regular: 400,
        medium: 500,
        bold: 700
    }
};
var breakpoints = {
    small: 320,
    medium: 768,
    large: 1176
};
var theme = {
    colors: colors,
    colorFamily: colorFamily,
    typography: typography,
    breakpoints: breakpoints,
    spacing: function (spacingUnit) {
        if (typeof spacingUnit === 'number') {
            console.warn('Spacing units of type "number" are deprecated and will be removed in a future release. Use "small" | "medium" | "large" | "xlarge" | "xxlarge" instead.' +
                '\n\nSee https://mortar.policygenius.com/?path=/story/design-guidelines-layout--page#spacing-units for design guidelines.');
            return "".concat(spacingUnit * exports.spacingBaseUnit, "rem");
        }
        return "".concat(SPACING_UNIT_VALUE_MAP[spacingUnit] * exports.spacingBaseUnit, "rem");
    }
};
exports.default = theme;
/*
FYI:
`util/generate-css.ts` depends on the structure of the theme object to create the css variables consumed by Mortar consumers.
It assumes the theme object has descriptive keys whose values are objects, strings or numbers.
There are two unique cases - `breakpoints` for which generate-css suffixes px to the value and `spacing` which is the only value that is currently a function.
If adding additional values that are unique cases, ensure you have updated `generate-css.ts`
*/
